import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { expandTheme } from 'utils/theme-util';

export const GtdStyles = (theme: Theme) => {
  const { palette } = expandTheme(theme);
  return createStyles({
    button: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minWidth: theme.spacing(13),
    },
    selectedButton: {
      backgroundColor: palette.primary.teal,
      color: palette.primary.white,
    },
    reportButton: {
      alignSelf: 'end',
    },
  });
};
